import { render, staticRenderFns } from "./StatusBadge.vue?vue&type=template&id=b11b7334&scoped=true&"
var script = {}
import style0 from "./StatusBadge.vue?vue&type=style&index=0&id=b11b7334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11b7334",
  null
  
)

export default component.exports